/* Helpers */
import { networksOrder } from "../../../helper/orders";
/* Components */
import Dashboard from "../../../components/common/dashboard/Dashboard";
import Header from "../../../components/common/Header";
import Icon from "../../../components/common/Icon";
import SearchBox from "../../../components/common/SearchBox";
import {getAdminNetworkList} from "../../../api/admin/networkReq";
import useAuth from "../../../hooks/useAuth";
import {useEffect, useState} from "react";
import usePager from "../../../hooks/usePager";


export default function Networks() {
    const { auth } = useAuth();
    const token = auth?.token;
    const [ networkList, setNetworkList ] = useState();
    const { currentPage, setCurrentPage, itemsPerPage, setTotalPages } = usePager();
    const [ totalItems, setTotalItems ] = useState();
    const [ filterParams, setFilterParams ] = useState({});

    const headers = [
        { label: "Identité", key : "name" },
        { label :"Siret", key : "siret" },
        { label :"Date création", key : "createdAt" }
    ];

    const apiNetworkList = async () => {
        const response = await getAdminNetworkList(token, currentPage, itemsPerPage, JSON.stringify(filterParams));
        setNetworkList(response?.networkList);
        setTotalItems(response?.totalItems);
    }

    useEffect(() => {
        setCurrentPage(1)
        setTotalPages(Math.ceil(totalItems / itemsPerPage))
    }, [ totalItems, itemsPerPage ]);

    useEffect(() => {
        apiNetworkList();
    }, [ token, currentPage, itemsPerPage, filterParams, totalItems ]);

    useEffect(() => {
        if (networkList?.length < 1) {
            apiNetworkList();
        }
    }, [ networkList ]);

    const sources = "fa fa-users";
    return (
        <main className="admin">
            <Header parent="Administration" location="Réseaux" slug={`/admin/accueil`} />
            <div className="content-container">
                <Icon source={sources} color="blue" span="Réseaux"/>
                <SearchBox location="Réseaux" headers={headers} filename="Réseaux" setFilterParams={setFilterParams} />
                <div className="dashboard">
                    <Dashboard totalItems={totalItems} apiNetworkList={apiNetworkList} location="Réseaux" dataObject={networkList || []}
                        order={networksOrder}/>
                </div>
            </div>
        </main>
    )
}